import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../../shared/utility';

const initialState = {
  staticIPConfigData: null,
  loading: false,
  error: false,
};

const setStaticIPConfig = (state, action) => {
  return updateObject(state, { staticIPConfigData: action.staticIPConfigData, loading: false, error: false });
};

const fetchStaticIPConfigFailed = (state) => {
  return updateObject(state, { error: true, loading: false });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.INIT_STATIC_IP_CONFIG: return updateObject(state, { loading: true });
    case actionTypes.SET_STATIC_IP_CONFIG: return setStaticIPConfig(state, action);
    case actionTypes.FETCH_STATIC_IP_CONFIG_FAILED: return fetchStaticIPConfigFailed(state);
    default: return state;
  }
};

export default reducer;
